var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm',{attrs:{"title":"登録完了 ","description":"PolariStationにご登録いただき誠にありがとうございます。ご指定のメールアドレス＆パスワードでログインしてご使用ください。","to":"login"}})}
var staticRenderFns = []

export { render, staticRenderFns }